import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getBaseLabel, getQueryTypeLabelAndIcon } from 'src/utils';
import {
  changeSelectedApplicationTab,
  removeApplicationTab,
  requestCreateAudience,
  showEditAudienceModal,
  showModal,
  updateTabLoadingStatus,
  openSaveModal,
  requestSaveAudience,
  requestRenameItem,
  showCompareAudienceModal,
  addApplicationDroppingEntity,
  addApplicationTab,
  requestRepository,
  sendEvent,
  sendStateChange,
  updateApplicationTab,
  addEmptyTab,
} from '../../actions';
import { ApplicationTabs, ApplicationTab } from '../../components';
import MicroFrontend from '../../MicroFrontend';
import { APPS_MAP, MFE_URLS } from '../../constants/config';

const affinityMFEHost = MFE_URLS.AFFINITY;
const segmentationMFEHost = MFE_URLS.SEGMENTATION;
const compareMFEHost = MFE_URLS.COMPARE;

const AffinityMFE = ({ queries, instanceId, onError, repositoryCollapsed }) => (
  <MicroFrontend
    host={affinityMFEHost}
    name="AffinityMFE"
    query={queries[0]}
    instanceId={instanceId}
    onError={onError}
    repositoryCollapsed={repositoryCollapsed}
  />
);

const SegmentationMFE = ({
  queries,
  instanceId,
  onError,
  repositoryCollapsed,
}) => (
  <MicroFrontend
    host={segmentationMFEHost}
    name="SegmentationMFE"
    query={queries[0]}
    instanceId={instanceId}
    onError={onError}
    repositoryCollapsed={repositoryCollapsed}
  />
);

const CompareMFE = ({ queries, instanceId, onError, repositoryCollapsed }) => (
  <MicroFrontend
    host={compareMFEHost}
    name="CompareMFE"
    query={queries}
    instanceId={instanceId}
    onError={onError}
    repositoryCollapsed={repositoryCollapsed}
  />
);
const mapApps = {
  analyze: AffinityMFE,
  segmentation: SegmentationMFE,
  compare: CompareMFE,
};

const getApp = (
  appName,
  instanceId,
  data,
  onError,
  taxonomy,
  repositoryCollapsed
) => {
  const SpecifiedApp = mapApps[appName];
  if (!SpecifiedApp) {
    return null;
  }

  let queries = [];

  if (Array.isArray(data) && data.length > 0) {
    queries = data.map(audience => ({
      ...audience,
      baseLabel: audience.metadata && getBaseLabel(audience.metadata, taxonomy),
      queryTypeLabelAndIcon: getQueryTypeLabelAndIcon(
        audience.metadata && audience.metadata.query_type
      ),
    }));
  } else {
    queries = [
      {
        ...data,
        baseLabel: getBaseLabel(data.metadata, taxonomy),
        queryTypeLabelAndIcon: getQueryTypeLabelAndIcon(
          data.metadata && data.metadata.query_type
        ),
      },
    ];
  }

  if (queries.some(q => !q.baseLabel)) {
    return null;
  }

  return (
    <SpecifiedApp
      instanceId={instanceId}
      queries={queries}
      onError={onError}
      repositoryCollapsed={repositoryCollapsed}
    />
  );
};

class TabsContainer extends Component {
  componentDidMount() {
    window.addEventListener(
      'TAB_APP_QUERY_RESPONDED',
      this.handleTabAppQueryResponded
    );
    window.addEventListener('TAB_APP_SAVE_QUERY', this.handleSaveQuery);
    window.addEventListener('TAB_APP_PREVIEW_QUERY', this.handlePreviewQuery);
    window.addEventListener('TAB_APP_EDIT_QUERY', this.handleEditQuery);
    window.addEventListener('TAB_APP_SHARE_QUERY', this.handleShareQuery);
    window.addEventListener('TAB_APP_COMPARE_QUERY', this.handleCompareQuery);
    window.addEventListener(
      'TAB_APP_REQUEST_CREATE_AUDIENCE',
      this.handleRequestCreateAudience
    );
    window.addEventListener(
      'TAB_APP_REQUEST_ANALYZE_AUDIENCE',
      this.handleRequestAnalyzeAudience
    );
    window.addEventListener(
      'TAB_APP_REQUEST_COMPARE_AUDIENCES',
      this.handleRequestCompareAudiences
    );
    window.addEventListener(
      'TAB_APP_REQUEST_SEGMENTATION_AUDIENCE',
      this.handleRequestSegmentationAudience
    );
    window.addEventListener(
      'TAB_APP_REFRESH_REPOSITORY',
      this.handleRefreshRepository
    );
    window.addEventListener('TAB_APP_ANALYZE_EVENT', this.handleSendEvent);
    window.addEventListener(
      'TAB_APP_HOTJAR_STATE_CHANGE',
      this.handleStateChangeHotjarEvent
    );
    window.addEventListener(
      'TAB_APP_REQUEST_MISSING_ITEM',
      this.handleRequestMissingItem
    );
  }

  componentWillUnmount() {
    window.removeEventListener(
      'TAB_APP_QUERY_RESPONDED',
      this.handleTabAppQueryResponded
    );
    window.removeEventListener('TAB_APP_SAVE_QUERY', this.handleSaveQuery);
    window.removeEventListener(
      'TAB_APP_PREVIEW_QUERY',
      this.handlePreviewQuery
    );
    window.removeEventListener('TAB_APP_EDIT_QUERY', this.handleEditQuery);
    window.removeEventListener('TAB_APP_SHARE_QUERY', this.handleShareQuery);
    window.removeEventListener(
      'TAB_APP_COMPARE_QUERY',
      this.handleCompareQuery
    );
    window.removeEventListener(
      'TAB_APP_REQUEST_MISSING_ITEM',
      this.handleRequestMissingItem
    );
    window.removeEventListener(
      'TAB_APP_REQUEST_CREATE_AUDIENCE',
      this.handleRequestCreateAudience
    );
    window.removeEventListener(
      'TAB_APP_REQUEST_ANALYZE_AUDIENCE',
      this.handleRequestAnalyzeAudience
    );
    window.removeEventListener(
      'TAB_APP_REQUEST_COMPARE_AUDIENCES',
      this.handleRequestCompareAudiences
    );
    window.removeEventListener(
      'TAB_APP_REQUEST_SEGMENTATION_AUDIENCE',
      this.handleRequestSegmentationAudience
    );
    window.removeEventListener(
      'TAB_APP_REFRESH_REPOSITORY',
      this.handleRefreshRepository
    );
    window.removeEventListener('TAB_APP_ANALYZE_EVENT', this.handleSendEvent);
    window.removeEventListener(
      'TAB_APP_HOTJAR_STATE_CHANGE',
      this.handleStateChangeHotjarEvent
    );
  }

  handleSendEvent = event => {
    if (event.detail) {
      this.props.sendEvent(event.detail.event);
    }
  };

  handleStateChangeHotjarEvent = event => {
    if (event.detail) {
      this.props.sendStateChange(event.detail.url);
    }
  };

  handleRequestMissingItem = event => {
    this.props.showModal(
      {
        isOpen: true,
        position: 'center',
      },
      'RequireMissingItem'
    );
  };

  handleRefreshRepository = event => {
    if (event.detail) {
      this.props.requestRepository('recent');
    }
  };

  handleSaveQuery = event => {
    if (event.detail) {
      this.props.openSaveModal(event.detail);
    }
  };

  handlePreviewQuery = event => {
    if (event.detail) {
      this.props.showModal(
        { isOpen: true, position: 'right', selectedItem: event.detail },
        'AudiencePreview'
      );
    }
  };

  handleShareQuery = event => {
    if (event.detail) {
      this.props.showModal(
        { isOpen: true, position: 'center', selectedItem: event.detail },
        'ShareAudience'
      );
    }
  };

  handleCompareQuery = event => {
    if (event.detail && event.detail.queries) {
      event.detail.queries.forEach(query =>
        this.props.addApplicationDroppingEntity(
          { ...query, fromCompare: true },
          APPS_MAP.COMPARE
        )
      );
    }
  };

  handleEditQuery = event => {
    if (event.detail) {
      this.props.showEditAudienceModal({ audience: event.detail });
    }
  };

  handleTabAppQueryResponded = event => {
    this.props.updateTabLoadingStatus(event.detail.tabInstanceId);
  };

  handleOnTabRemoveRequest = id => {
    this.props.removeApplicationTab(id);
  };

  handleOnSelectedTabChange = id => {
    this.props.changeSelectedApplicationTab(id);
  };

  handleOnAppLoadError = id => {
    this.props.updateTabLoadingStatus(id);
  };

  handleRequestCreateAudience = event => {
    this.props.requestCreateAudience(event.detail, 'analyze');
  };

  handleRequestAnalyzeAudience = event => {
    this.props.addApplicationTab(event.detail, APPS_MAP.ANALYZE);
  };

  handleRequestCompareAudiences = event => {
    this.props.addApplicationTab(event.detail, APPS_MAP.COMPARE);
  };

  handleRequestSegmentationAudience = event => {
    this.props.addApplicationTab(event.detail, APPS_MAP.SEGMENTATION);
  };

  render() {
    const { tabs, timeframes, taxonomyList, layout } = this.props;

    return (
      <ApplicationTabs
        selectedTab={tabs.selectedTabId}
        timeframes={timeframes}
        taxonomyList={taxonomyList}
        onTabChange={this.handleOnSelectedTabChange}
        onTabClose={this.handleOnTabRemoveRequest}
        requestSaveAudience={this.props.requestSaveAudience}
        requestRenameItem={this.props.requestRenameItem}
      >
        {tabs.list.map(tab => (
          <ApplicationTab
            id={tab.id}
            selected={tabs.selectedTabId === tab.id}
            tab={tab}
            key={`tab-${tab.id}`}
          >
            {getApp(
              tab.app,
              tab.id,
              tab.audience,
              this.handleOnAppLoadError,
              taxonomyList,
              layout.repositorySize === 'collapsed'
            )}
          </ApplicationTab>
        ))}
      </ApplicationTabs>
    );
  }
}

const mapDispatchToProps = {
  changeSelectedApplicationTab,
  removeApplicationTab,
  showEditAudienceModal,
  showModal,
  updateTabLoadingStatus,
  requestCreateAudience,
  openSaveModal,
  requestSaveAudience,
  requestRenameItem,
  showCompareAudienceModal,
  addApplicationDroppingEntity,
  addApplicationTab,
  requestRepository,
  sendEvent,
  sendStateChange,
  addEmptyTab,
  updateApplicationTab,
};

const mapStateToProps = state => ({
  me: state.me,
  tabs: state.tabs,
  timeframes: state.timeframes,
  taxonomyList: state.taxonomyList,
  layout: state.layout,
});

export default connect(mapStateToProps, mapDispatchToProps)(TabsContainer);
